import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { toShortNumFormat } from '@/common/lib/toShortNumFormat';
import { type ContractType } from '@/common/types/contract';
import { CompleteContractAnimationContext } from '@/components/Animations/CompleteContractAnimation/context';
import { selectSpecContractRewardsByKind } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import { ContractRewardItem } from '../ContractRewardItem/ContractRewradItem';

import { config } from './config';

interface ContractRewardsListProps {
  kind: ContractType;
  className?: string;
}

const ContractRewardsList: FC<ContractRewardsListProps> = ({
  kind,
  className,
}) => {
  const { t } = useTranslation();
  const data = useAppSelector((state) =>
    selectSpecContractRewardsByKind(state, kind),
  );
  const { isAnimationStart } = useContext(CompleteContractAnimationContext);

  return (
    <div className={cn('flex w-full px-4', className)}>
      {data?.map(({ item, value, extraPoints }, index) => {
        const props = {
          ...config[item],
          classNames: { ...config[item].classNames, wrapper: 'flex-1' },
        };

        return (
          !isAnimationStart && (
            <ContractRewardItem
              key={index}
              {...props}
              description={t(props.description)}
              title={toShortNumFormat(value)}
              extraText={extraPoints ? extraPoints.toString() : undefined}
              kind={item}
            />
          )
        );
      })}
    </div>
  );
};

export { ContractRewardsList };
